export default __webpack_public_path__ + "static/media/app-create.5c5b255f.svg";